export default __webpack_public_path__ + "assets/moon-solid.svg";